import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { CoreModule } from '../core/core.module';

// Imports the Main Application Component (This manages the layout for the application)
import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SignedoutComponent } from './signedout/signedout.component';

// Imports the Routing Module, this manages the initial route setting
import { AppRoutingModule } from './app.routes';

import { SharedModule } from '../shared/shared.module';

import {
  XpoButtonModule,
  XpoCoreModule,
  XpoFooterModule,
  XpoHeaderModule,
  XpoIconModule,
  XpoImgModule,
  XpoInternalAppModule,
  XpoMainModule,
  XpoMenuBarModule,
  XpoSnackBarModule,
} from '@xpo/common';

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    SignedoutComponent,
  ],
  imports: [
    BrowserModule,
    CoreModule,
    AppRoutingModule,
    XpoButtonModule,
    XpoCoreModule,
    XpoFooterModule,
    XpoHeaderModule,
    XpoIconModule,
    XpoImgModule,
    XpoInternalAppModule,
    XpoMainModule,
    XpoMenuBarModule,
    XpoSnackBarModule,
    SharedModule,
  ],
  providers: [],
  entryComponents: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule { }



// WEBPACK FOOTER //
// /ng-app/src/app/app.module.ts